export const EVENT_BUS_CONTEXT = 'api'
export const EVENT_BUS_TARGET = 'error'
export const REQUEST_TIMEOUT_MS = 10000

/** Uploads stream for minutes, so the regular request timeout would abort them mid-flight. */
export const UPLOAD_TIMEOUT_MS = 10 * 60 * 1000
